import { useIntl } from "react-intl";
import { Box, styled, Typography } from "@mui/material";
import { getInvertColor } from "utils/themeUtils";
import { LightBulbIcon } from "./LightBulbIcon";
interface Props {
	tipsTexts: string[];
	intervalMS?: number;
}

export const GameTips = ({ tipsTexts, intervalMS = 5000 }: Props) => {
	// TODO: Implement carousel
	const intl = useIntl();
	return (
		<Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" textAlign="center">
			<LightBulbIcon />
			<TipsTitle data-testid="tips_title">
				{intl.formatMessage({
					id: "TIPS.game-tips.tips",
				})}
			</TipsTitle>
			<TipsContent data-testid="tips_content">{tipsTexts[0]}</TipsContent>
		</Box>
	);
};

const TipsTitle = styled(Typography)(({ theme }) => ({
	fontSize: "32px",
	fontWeight: 800,
	color: getInvertColor(theme.palette.primary.main),
	marginBottom: 16,
	marginTop: 8,
}));
const TipsContent = styled(Typography)(({ theme }) => ({
	fontSize: 20,
	fontWeight: 800,
	lineHeight: 1.3,
	color: getInvertColor(theme.palette.primary.main),
}));
